/* eslint-disable max-len */
import React from 'react';
import { Route } from 'react-router-dom';

const Home = () => (
  <Route path="/">
    <div className="container">
      <h1 style={{ marginBottom: '40px' }}>Welcome to Math Magic!</h1>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quos, fugit odit molestiae praesepossimus. Veniam, architecto. Labore doloremque illo minus odit nulla nesciunt eius omnis, adipisci, possimus quosexercitationem.
        Accusamus praesentium, qui minus quam ipsa, illo reprehenderit maxime deserunt aut, iste cupiditate est repellendus natus doloremque sapiente accusantium obcaecati fugiat facere suscipit? Dolores ducimus quis, laborum esse assumenda autem.
        Enim aut, ullam, ex maxime commodi minima nemo ea, consequatur dignissimos dolore quo necessitatibus officiis voluptatum voluptates cum! Iste dolorum obcaecati ipsam incidunt distinctio debitis a, atque consectetur dolores amet!
        Molestiae impedit cupiditate nam non quibusdam, harum eligendi doloribus magnam ea.
      </p>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quos, fugit odit molestiae praesepossimus. Veniam, architecto. Labore doloremque illo minus odit nulla nesciunt eius omnis, adipisci, possimus quosexercitationem.
      </p>
    </div>
  </Route>
);
export default Home;
